import { OrderLanguageMap, OrderI18nTemplate } from './orderTypes';

export const orderUiHistoryDetailTemplate: OrderLanguageMap<OrderI18nTemplate['ui']['historyDetail']> = {
  zh: {
    orderIdNotFound: '订单ID不存在',
    parsePendingOrderDataFailed: '解析待处理订单数据失败',
    paymentProcessingLeaveWarning: '正在支付处理中，批量订单可能需要1-5分钟，请不要刷新或关闭页面。',
    processing: '处理中...',
    orderNotFound: '订单不存在',
    invalidOrderId: '订单ID无效',
    operationFailedRetry: '订单处理未完成，请检查订单状态',
    labelGeneratingRetry: '面单正在生成中，请稍后重试',
    fetchLabelFailed: '获取面单失败',
    labelDownloadStarted: '面单已开始下载',
    labelsFetchedSuccessfully: '面单获取成功',
    batchOrder: '批量下单',
    singleOrder: '逐一下单',
    deliveryAny: '无所谓',
    delivery2to3Days: '2-3 天',
    delivery3to5Days: '3-5 天',
    delivery1to5Days: '1-5 天',
    orderContainsCancelledLabelsCannotPay: '订单中包含已取消的面单，无法完成支付。请重新新建订单。',
    labelCreationFailed: '面单新建失败，请稍后重试',
    paymentFailedRetryOrModify: '支付失败，请重试或修改订单。',
    networkIssueRetry: '网络连接异常，请检查网络后重试',
    requestTimeoutRetry: '请求超时，请稍后重试',
    networkConnectionFailedRetry: '网络连接失败，请检查网络后重试',
    internalServerErrorRetry: '服务器内部错误，请稍后重试',
    serviceUnavailableRetry: '服务暂时不可用，请稍后重试',
    serviceEndpointNotFoundContactSupport: '服务接口不存在，请联系客服',
    insufficientPermissionsRelogin: '权限不足，请重新登录',
    sessionExpiredRelogin: '登录已过期，请重新登录',
    paymentProcessingDontRefresh: '支付正在处理，请不要刷新或关闭页面',
    modify: '修改',
    pay: '支付',
    exportPackageInfo: '导出包裹信息',
    downloadFailedRetryFile: '下载失败订单信息',
    failedRetryDownloadFailed: '下载失败订单信息失败，请稍后重试',
    downloading: '下载中...',
    downloadAllLabels: '下载全部面单',
    orderTitlePrefix: '订单',
    totalPrefix: '共',
    packageUnit: '个包裹',
    averagePackageCost: '包裹均价 (补扣免责)',
    totalOrderCost: '订单总价 (补扣免责)',
    savePercentPrefix: '比门市价节省',
    savePercentSuffix: '%',
    shippingRequirement: '快递需求',
    senderAddress: '发货地址',
    shipmentDetails: '快递明细',
    amongThem: '其中',
    failedByInsufficientBalanceSuffix: '个包裹因账号方余额不足下单失败，账号方充值后可重新下单。',
    reorder: '重新下单',
    modifyBatchOrderTitle: '修改批量订单',
    modifyBatchOrderMessage: '修改批量订单需要重新上传地址数据，是否继续？',
    continueModify: '继续修改',
    cancel: '取消',
    whenModifyingBatchOrder: '修改批量订单时：',
    batchModifyTips: [
      '需要重新上传包含收件人地址的Excel文件',
      '当前的包裹信息将被清除',
      '发件人地址和快递偏好会保留',
    ],
    operationFailedTitle: '订单处理未完成',
    currentOrderStatusPrefix: '当前订单状态：',
    contactSupport: '如需帮助，请联系客服',
    orderCancelledSuccessfully: '订单已成功取消',
    refundRequestSubmitted: '退款申请已提交',
    uspsOrderCancelFeeNote: '注意：订单中包含USPS面单，取消将收取10%手续费',
    uspsRefundAmountFormula90: 'USPS面单退款金额 = 原金额 × 90%',
    csvHeaders: [
      '电商订单号',
      '收件人',
      '运单号',
      '费用',
      '状态',
      '错误信息',
      '面单新建日期',
      '预计送达时间',
      '包裹长度',
      '包裹宽度',
      '包裹高度',
      '重量',
      '街道',
      '城市',
      '州',
      '邮编',
      '国家',
      '快递公司',
      '服务类型',
    ],
  },
  en: {
    orderIdNotFound: 'Order ID does not exist',
    parsePendingOrderDataFailed: 'Failed to parse pending order data',
    paymentProcessingLeaveWarning: 'Payment is processing. Batch orders may take 1-5 minutes. Please do not refresh or close this page.',
    processing: 'Processing...',
    orderNotFound: 'Order not found',
    invalidOrderId: 'Invalid order ID',
    operationFailedRetry: 'Operation failed. Please try again.',
    labelGeneratingRetry: 'Label is being generated. Please retry shortly.',
    fetchLabelFailed: 'Failed to fetch label',
    labelDownloadStarted: 'Label download started',
    labelsFetchedSuccessfully: 'Labels fetched successfully',
    batchOrder: 'Batch Order',
    singleOrder: 'Single Order',
    deliveryAny: 'Any',
    delivery2to3Days: '2-3 days',
    delivery3to5Days: '3-5 days',
    delivery1to5Days: '1-5 days',
    orderContainsCancelledLabelsCannotPay: 'This order contains cancelled labels and cannot be paid. Please create a new order.',
    labelCreationFailed: 'Label creation failed. Please try again.',
    paymentFailedRetryOrModify: 'Payment failed. Please retry or modify the order.',
    networkIssueRetry: 'Network issue detected. Please check your connection and retry.',
    requestTimeoutRetry: 'Request timed out. Please try again.',
    networkConnectionFailedRetry: 'Network connection failed. Please check your connection and retry.',
    internalServerErrorRetry: 'Internal server error. Please try again later.',
    serviceUnavailableRetry: 'Service temporarily unavailable. Please try again later.',
    serviceEndpointNotFoundContactSupport: 'Service endpoint not found. Please contact support.',
    insufficientPermissionsRelogin: 'Insufficient permissions. Please log in again.',
    sessionExpiredRelogin: 'Session expired. Please log in again.',
    paymentProcessingDontRefresh: 'Payment is processing. Please do not refresh or close this page.',
    modify: 'Modify',
    pay: 'Pay',
    exportPackageInfo: 'Export Package Info',
    downloadFailedRetryFile: 'Download Failed Retry File',
    failedRetryDownloadFailed: 'Failed to download retry file. Please try again.',
    downloading: 'Downloading...',
    downloadAllLabels: 'Download All Labels',
    orderTitlePrefix: 'Order',
    totalPrefix: 'Total',
    packageUnit: 'packages',
    averagePackageCost: 'Average Package Cost',
    totalOrderCost: 'Total Order Cost',
    savePercentPrefix: 'Save ',
    savePercentSuffix: '% vs counter price',
    shippingRequirement: 'Shipping Requirement',
    senderAddress: 'Sender Address',
    shipmentDetails: 'Shipment Details',
    amongThem: 'Among them',
    failedByInsufficientBalanceSuffix: ' packages failed due to insufficient account balance. You can reorder after recharging.',
    reorder: 'Reorder',
    modifyBatchOrderTitle: 'Modify Batch Order',
    modifyBatchOrderMessage: 'Modifying a batch order requires re-uploading address data. Continue?',
    continueModify: 'Continue',
    cancel: 'Cancel',
    whenModifyingBatchOrder: 'When modifying a batch order:',
    batchModifyTips: [
      'You need to re-upload the Excel file with recipient addresses',
      'Current package information will be cleared',
      'Sender address and shipping preferences will be preserved',
    ],
    operationFailedTitle: 'Operation Failed',
    currentOrderStatusPrefix: 'Current order status:',
    contactSupport: 'If you need help, please contact support',
    orderCancelledSuccessfully: 'Order cancelled successfully',
    refundRequestSubmitted: 'Refund request submitted',
    uspsOrderCancelFeeNote: 'Note: This order contains USPS labels. Cancelling charges a 10% fee.',
    uspsRefundAmountFormula90: 'USPS refund amount = original amount × 90%',
    csvHeaders: [
      'E-commerce Order Number',
      'Recipient',
      'Tracking Number',
      'Cost',
      'Status',
      'Error Message',
      'Label Created Date',
      'Estimated Delivery Time',
      'Package Length',
      'Package Width',
      'Package Height',
      'Weight',
      'Street',
      'City',
      'State',
      'Zipcode',
      'Country',
      'Carrier',
      'Service',
    ],
  },
};
